<template>
	<div>
		<SwitchOption option-name="Add a property as results’ description" :switch-model.sync="customEnabled" />
		<div v-if="customEnabled">
			<div class="custom-description-title">Choose the source you want as sample:</div>
			<SearchFieldForCustomSettings :field="localField" @updateLocalField="({ key, value }) => updateLocalField({ key, value })" />
			<div v-if="!selectedCustomError && appSampleOptions.length > 0" class="custom-values">
				<SwitchOption option-name="Custom Description" :switch-model.sync="customDescriptionEnabled" />
				<div v-if="customDescriptionEnabled" class="pb-2">
					<div class="custom-description-sub-title">Choose the source for your description:</div>
					<AppSelect dense outlined v-model="selectedCustomDescriptionSource" :items="appSampleOptions" />
				</div>
				<SwitchOption option-name="Custom Image" :switch-model.sync="customImageEnabled" />
				<div v-if="customImageEnabled" class="pb-2">
					<div class="custom-description-sub-title">Choose the source for your image:</div>
					<AppSelect dense outlined v-model="selectedCustomImageSource" :items="appSampleOptions" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { flatten } from '@/utils/helpers';
import SearchFieldForCustomSettings from './SearchFieldForCustomSettings.vue';
import SwitchOption from '../FieldOptions/SwitchOption';
export default {
	name: 'CustomUserSettings',
	props: {
		localField: { type: Object },
	},
	components: {
		SwitchOption,
		SearchFieldForCustomSettings,
	},
	computed: {
		appSampleOptions() {
			if (!this.localField.metadata.options.custom?.sample?.value) {
				return [];
			}
			const value = this.localField.metadata.options.custom.sample.value;
			if (!value.item) {
				return [];
			}
			return Object.keys(flatten(value.item, { safe: true })).map((key) => ({
				text: key,
				value: key,
			}));
		},
		selectedCustomDescriptionSource: {
			get() {
				return this.localField.metadata.options.custom.description?.value;
			},
			set(value) {
				this.updateLocalField({ key: 'metadata.options.custom.description.value', value });
			},
		},
		selectedCustomImageSource: {
			get() {
				return this.localField.metadata.options.custom.image?.value;
			},
			set(value) {
				this.updateLocalField({ key: 'metadata.options.custom.image.value', value });
			},
		},
		customDescriptionEnabled: {
			get() {
				return this.localField.metadata.options.custom?.description?.enabled || false;
			},
			set(value) {
				if (!this.localField.metadata.options.custom.description) {
					//default
					this.updateLocalField({ key: 'metadata.options.custom.description', value: { enabled: false, value: undefined } });
				}
				this.updateLocalField({ key: 'metadata.options.custom.description.enabled', value });
			},
		},
		customImageEnabled: {
			get() {
				return this.localField.metadata.options.custom?.image?.enabled || false;
			},
			set(value) {
				if (!this.localField.metadata.options.custom.image) {
					//default
					this.updateLocalField({ key: 'metadata.options.custom.image', value: { enabled: false, value: undefined } });
				}
				this.updateLocalField({ key: 'metadata.options.custom.image.enabled', value });
			},
		},
		customEnabled: {
			get() {
				return this.localField.metadata.options.custom?.enabled || false;
			},
			set(value) {
				if (!this.localField.metadata.options.custom) {
					//default
					this.updateLocalField({
						key: 'metadata.options.custom',
						value: {
							enabled: false,
							sample: { value: undefined },
							description: { enabled: false, value: undefined },
							image: { enabled: false, value: undefined },
						},
					});
				}
				this.updateLocalField({
					key: 'metadata.options.custom.enabled',
					value,
				});
				if (value === false) {
					this.customImageEnabled = false;
					this.customDescriptionEnabled = false;
				}
			},
		},
		selectedCustomError() {
			return this.localField.metadata.options.custom?.sample?.value && !this.localField.metadata.options.custom?.sample?.value?.item;
		},
	},
	methods: {
		updateLocalField({ key, value }) {
			this.$emit('updateLocalField', { key, value });
		},
	},
};
</script>
<style scoped lang="scss">
.custom-description-title {
	font-size: small;
}
.custom-values {
	padding: 4px;
	border: 1px solid #e7e7ed;
	.custom-description-sub-title {
		font-size: small;
		opacity: 0.7;
	}
}
</style>
